// src/property-drafts/propertyDraftsApi.ts
import { apiClient } from "@maat/api-base";
var propertyDraftsApi = {
  getDrafts: async () => {
    return apiClient.get("/main/api/property-drafts");
  },
  getDraft: async (draftId) => {
    return apiClient.get(`/main/api/property-drafts/${draftId}`);
  },
  createDraft: async (payload) => {
    return apiClient.post("/main/api/property-drafts", payload);
  },
  updateDraft: async (draftId, payload) => {
    return apiClient.put(`/main/api/property-drafts/${draftId}`, payload);
  },
  deleteDraft: async (draftId) => {
    return apiClient.delete(`/main/api/property-drafts/${draftId}`);
  }
};

export {
  propertyDraftsApi
};
